const i18n = {
  locales: [
    {
      code: 'fr',
      file: 'fr.js',
      name: 'French',
    },
    {
      code: 'en',
      file: 'en.js',
      name: 'English',
    },
    {
      code: 'ja',
      file: 'ja.js',
      name: 'Japanese',
    },
    {
      code: 'es',
      file: 'es.js',
      name: 'Spanish',
    },
    {
      code: 'it',
      file: 'it.js',
      name: 'Italian',
    },
    {
      code: 'pt',
      file: 'pt.js',
      name: 'Portuguese',
    },
    {
      code: 'nl',
      file: 'nl.js',
      name: 'Dutch',
    },
    {
      code: 'de',
      file: 'de.js',
      name: 'German',
    },
    {
      code: 'ms',
      file: 'ms.js',
      name: 'Malay',
    },
    {
      code: 'th',
      file: 'th.js',
      name: 'Thai',
    },
    {
      code: 'fil',
      file: 'fil.js',
      name: 'Filipino',
    },
    {
      code: 'zh',
      file: 'zh.js',
      name: 'Simplified Chinese',
    },
    {
      code: 'ar',
      file: 'ar.js',
      name: 'Arabic',
    },
  ],
  strategy: 'no_prefix',
  lazy: true,
  langDir: 'locales/',
  defaultLocale: 'en',
  detectBrowserLanguage: false,
  vueI18n: {
    fallbackLocale: 'en',
  },
}

export { i18n }
